import forEach from "lodash-es/forEach.js";
import isArray from "lodash-es/isArray.js";
import isPlainObject from "lodash-es/isPlainObject.js";
const flatten = (obj = {}) => {
  const result = {};
  const lFlatten = (collection, prefix = "", suffix = "") => {
    forEach(collection, (value, key) => {
      const path = `${prefix}${key}${suffix}`;
      if (isArray(value) === true) {
        lFlatten(value, `${path}[`, "]");
      } else if (isPlainObject(value) === true) {
        lFlatten(value, `${path}.`);
      } else {
        result[path] = value;
      }
    });
  };
  lFlatten(obj);
  return result;
};
export {
  flatten
};
